"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BINARY_OPERATIONS_KEY = exports.QueryEditorMode = void 0;
var QueryEditorMode;
(function (QueryEditorMode) {
    QueryEditorMode["Code"] = "code";
    QueryEditorMode["Builder"] = "builder";
})(QueryEditorMode = exports.QueryEditorMode || (exports.QueryEditorMode = {}));
exports.BINARY_OPERATIONS_KEY = 'Binary operations';
//# sourceMappingURL=types.js.map